import { render, staticRenderFns } from "./MainApplyModal.vue?vue&type=template&id=6b5209f0&scoped=true&"
import script from "./MainApplyModal.vue?vue&type=script&lang=js&"
export * from "./MainApplyModal.vue?vue&type=script&lang=js&"
import style0 from "./MainApplyModal.vue?vue&type=style&index=0&id=6b5209f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5209f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b5209f0')) {
      api.createRecord('6b5209f0', component.options)
    } else {
      api.reload('6b5209f0', component.options)
    }
    module.hot.accept("./MainApplyModal.vue?vue&type=template&id=6b5209f0&scoped=true&", function () {
      api.rerender('6b5209f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/workPermits/Modals/MainApplyModal.vue"
export default component.exports